module.exports = __webpack_public_path__ + "img/3.824f512f.png";